<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <li class="currentNode"><a>合作智库</a></li>
            </ul>
            <div class="page-main">
                <h3>合作智库展示</h3>
                <ul class="medical-ul">
                    <li class="medical-item">
                        <h3>中国医学科学院北京协和医院</h3>
                        <div class="medical-item-btm">
                            <p class="subTitle">北京协和医院是全国顶尖医院，综合总实力最强设有27个疑难杂症会诊中心。</p>
                            <p><label>简称：</label></p>
                            <p><label>性质：</label></p>
                            <p><label>地址：</label></p>
                            <p><label>备注：</label></p>
                            <el-divider>特色诊室</el-divider>
                            <p class="ellipsis_four">风湿科(全国第一)、普通外科(全国第一)、妇产科(全国第一)、内分泌科(全国第二)、消化内科(全国第二)、重症医学(全国第二)、神经内科(全国第二)、整形外科(全国第四)、五官科科(全国第五)</p>
                        </div>
                    </li>
                    <li class="medical-item">
                        <h3>中国医学科学院北京协和医院</h3>
                        <div class="medical-item-btm">
                            <p class="subTitle">北京协和医院是全国顶尖医院，综合总实力最强设有27个疑难杂症会诊中心。</p>
                            <p><label>简称：</label></p>
                            <p><label>性质：</label></p>
                            <p><label>地址：</label></p>
                            <p><label>备注：</label></p>
                            <el-divider>特色诊室</el-divider>
                            <p class="ellipsis_four">风湿科(全国第一)、普通外科(全国第一)、妇产科(全国第一)、内分泌科(全国第二)、消化内科(全国第二)、重症医学(全国第二)、神经内科(全国第二)、整形外科(全国第四)、五官科科(全国第五)</p>
                        </div>
                    </li>
                    <li class="medical-item">
                        <h3>中国医学科学院北京协和医院</h3>
                        <div class="medical-item-btm">
                            <p class="subTitle">北京协和医院是全国顶尖医院，综合总实力最强设有27个疑难杂症会诊中心。</p>
                            <p><label>简称：</label></p>
                            <p><label>性质：</label></p>
                            <p><label>地址：</label></p>
                            <p><label>备注：</label></p>
                            <el-divider>特色诊室</el-divider>
                            <p class="ellipsis_four">风湿科(全国第一)、普通外科(全国第一)、妇产科(全国第一)、内分泌科(全国第二)、消化内科(全国第二)、重症医学(全国第二)、神经内科(全国第二)、整形外科(全国第四)、五官科科(全国第五)</p>
                        </div>
                    </li>
                </ul>
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="total"
                    @current-change="handleCurrentChange">
                </el-pagination>
            </div>
            
        </div>
    </div>
</template>

<script>
export default {
    name:"",
    data() {
        return {
            tableData:[{
                "address":"李强签署国务院令 公布《生态保护补偿条例》",
                "date":"2023-10-11"
            },
            {
                "address":"国家发展改革委有关负责同《国家发展改革委部门关于支持内蒙古绿色低碳高质量发展若干政策措施的通知》",
                "date":"2023-10-11"
            }],
            total: 100,
         
        }
    },
    created() {
        console.log(this.data);
    },
    methods: {
        handleCurrentChange(pageNum) {

        }
    }
}
</script>

<style scoped>
.page-main{
    display: block;
    background: #fff;
    padding: 30px 20px;
    box-sizing: border-box;
}
.page-main h3 {
    color: #262626;
    font-size: 22px;
    text-align: center;
}
.medical-ul{
    padding: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
}
.medical-item h3{
    width: 384px;
    height: 60px;
    background: #116EBA;
    color: #fff;
    font-size: 18px;
    line-height: 60px;
}
.medical-item-btm{
    padding: 16px 20px;
    width: 384px;
    height: 346px;
    box-sizing: border-box;
    border: 1px solid #E5E5E5;
    background:#fff;
}
.medical-item-btm p {
    line-height: 26px;
    color: #6A6A6A;

}
.subTitle {
    margin-bottom: 10px;
}
.el-divider {
    background: #116EBA;
}
.el-divider__text{
    color: #116EBA;
    font-size:18px;
}
</style>